import React from 'react'

const CusParagraph = (props) => {
    return (   
        <div className="dcPg fbaPSize">        
            {props.lblname}
        </div>
    )
}

export default CusParagraph
